const initialState = {
    bids: [],

    fetching: false,
    fetched: false,
    error: null,
}

export function bidsMngtReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_BIDSMNGT_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "UPDATE_BIDS": {
            // redux bug workaround
            var curBids = Object.assign({}, state.bids)

            curBids.adminEmails.map((email) => {
                if (!email.name.includes(";")) {
                    email.name += ";"
                    email.name += email.email
                }
                email.isActive = email.active
            })

            return { ...state, fetching: true, fetched: false, error: null, bids: curBids }
        }

        case "FETCH_BIDSMNGT_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "UPDATE_BIDS_REJECTED":
        case "FETCH_BIDSMNGT_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "UPDATE_BIDS_FULFILLED":
        case "FETCH_BIDSMNGT_LIST_FULFILLED": {
            action.payload.data.cabinetManufacturers.map((cab) => {
                cab.name = cab.name.replace(/\W/g, '')
            })

            action.payload.data.states.map((state) => {
                state.isActive = state.isBidActive
            })

            action.payload.data.adminEmails.map((email) => {
                if (!email.name.includes(";")) {
                    email.name += ";"
                    email.name += email.email
                }
                email.isActive = email.active
            })

            return { ...state, fetching: false, fetched: true, bids: action.payload.data }
        }

        case "NEW_BID_OPTION": {
            var curBids = Object.assign({}, state.bids)

            if (!curBids[action.payload.data.bid].filter((opt) => { return opt.name == action.payload.data.option }).length) {
                curBids[action.payload.data.bid].push({ id: -1, name: action.payload.data.option, isActive: false })

                return { ...state, bids: curBids }
            }
            else return state
        }

        case "ALL_BID_OPTIONS": {
            var curBids = Object.assign({}, state.bids)

            curBids[action.payload.data.bid].map((bid) => {
                bid.isActive = true
            })

            return { ...state, bids: curBids }
        }

        case "SEL_BID_OPTIONS": {
            var curBids = Object.assign({}, state.bids)

            action.payload.data.options.map((selopt) => {
                curBids[action.payload.data.bid].map((opt) => {
                    if (opt.name == selopt) {
                        opt.isActive = true
                    }
                })
            })

            return { ...state, bids: curBids }
        }

        case "UNSEL_BID_OPTION": {
            var curBids = Object.assign({}, state.bids)

            curBids[action.payload.data.bid].map((opt) => {
                if (opt.name == action.payload.data.option) {
                    opt.isActive = false
                }
            })

            return { ...state, bids: curBids }
        }

        case "NO_BID_OPTIONS": {
            var curBids = Object.assign({}, state.bids)

            curBids[action.payload.data.bid].map((bid) => {
                bid.isActive = false
            })

            return { ...state, bids: curBids }
        }

        case "ALL_ARCHIVE_OPTIONS": {
            var curBids = Object.assign({}, state.bids)

            curBids[action.payload.data.bid].map((bid) => {
                bid.displayAsActive = true
            })

            return { ...state, bids: curBids }
        }

        case "SEL_ARCHIVE_OPTIONS": {
            var curBids = Object.assign({}, state.bids)

            action.payload.data.options.map((selopt) => {
                curBids[action.payload.data.bid].map((opt) => {
                    if (opt.name == selopt) {
                        opt.displayAsActive = true
                    }
                })
            })

            return { ...state, bids: curBids }
        }

        case "UNSEL_ARCHIVE_OPTION": {
            var curBids = Object.assign({}, state.bids)

            curBids[action.payload.data.bid].map((opt) => {
                if (opt.name == action.payload.data.option) {
                    opt.displayAsActive = false
                }
            })

            return { ...state, bids: curBids }
        }

        case "NO_ARCHIVE_OPTIONS": {
            var curBids = Object.assign({}, state.bids)

            curBids[action.payload.data.bid].map((bid) => {
                bid.displayAsActive = false
            })

            return { ...state, bids: curBids }
        }

        case "FETCH_BIDSMNGT_ERROR": {
            return { ...state, error: null }
        }

        case "BIDSMNGT_ERROR": {
            return { ...state, error: null }
        }

        default:
            return state
    }
}
